module.exports =
  '_SETTING':
    'TITLE': '機能設定'
    'DISTANCE_UNIT': '距離単位'
    'METER': 'メートル'
    'YARD': 'ヤード'
    'EDIT_FRIEND': '登録・編集する'
    'MEMBERSHIP': '会員登録'
    'LBL_SUBSCRIBE': '無料会員'
    'SUBSCRIBE': '有料会員になる'
    'LBL_UNSUBSCRIBE': '有料会員'
    'UNSUBSCRIBE': '無料会員になる'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/setting/i18n/ja.coffee